module.exports = __webpack_public_path__ + "img/logo_reg360_a.14c838d8.jpg";